<template>
  <div>
    <el-card  style="height: 98%;">
      <el-row>
        <el-col :span="4">
          <!-- <el-input v-model="criteria.name" placeholder="阶梯名称"></el-input> -->
          <el-date-picker
            v-model="criteria.selectedYear"
            type="year"
            value-format="yyyy"
            placeholder="选择年份">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <div style="padding-left: 8px;">
            <el-button type="primary" icon="el-icon-search" @click="fetchPriceingDataByStairstep">查询</el-button>
          </div>
        </el-col>
        <el-col :span="4" :offset="12">
          <router-link :to="{path:'stairstep-edit'}" style="float:right;">
            <el-button type="primary" icon="el-icon-edit" plain>设置阶梯单价</el-button>
          </router-link>
        </el-col>
      </el-row>
      <br>

      <el-table
        :data="formattedPricingData"
        border
        style="width: 100%">
        <el-table-column
          prop="year"
          label="年份"
          width="180">
          <template slot-scope="scope">
            {{scope.row.year}} 年
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="阶梯名称">
        </el-table-column>
        <el-table-column
          prop="uplimit"
          label="上限（吨）"
          width="100">
        </el-table-column>
        <el-table-column
          prop="lowlimit"
          label="下限（吨）"
          width="100">
        </el-table-column>
        <el-table-column
          prop="stairtype"
          label="阶梯类型"
          width="120">
          <template slot-scope="scope">
            {{getStairTypeName(scope.row.stairtype)}}
          </template>
        </el-table-column>
        <el-table-column
          prop="speprice"
          label="指定单价（元/吨）"
          width="180">
          <template slot-scope="scope">
            {{scope.row.speprice ? scope.row.speprice : ''}}
          </template>
        </el-table-column>
        <el-table-column
          prop="speratio"
          label="上浮比例"
          width="180">
          <template slot-scope="scope">
            {{scope.row.speratio ? scope.row.speratio : ''}}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->

            <router-link :to="{path: `stairstep-edit?year=${scope.row.year}`}">
              <el-button type="text" size="small">详细</el-button>
              </router-link>
          </template>
        </el-table-column>
      </el-table>

    </el-card>
  </div>
</template>

<script>
import {
  getPriceingDataByStairstep
} from '@/apis/api'
import qs from 'qs'
import {PRICING_DATA_STAIRSTEP_MODIFIED} from '../topics'
import * as constants from '../constants'

export default {
  name: 'stairstep-search',
  data() {
    return {
      pricingData: {},
      isDirty: false,
      criteria: {
        selectedYear: null,
      }
    }
  },
  computed: {
    formattedPricingData() {
      let result = []
      Object.keys(this.pricingData).forEach(idx => {
        result.push(this.pricingData[idx][0])
      })
      return result
    }
  },
  activated() {
    if(this.isDirty) {
      this.fetchPriceingDataByStairstep()
      this.isDirty = false
    }
  },
  created() {
    this.fetchPriceingDataByStairstep()

    this.$bus.$on(PRICING_DATA_STAIRSTEP_MODIFIED, () => {
      this.isDirty = true
    })
  },
  methods: {
    initYearList(n = 10) {
      let result = [], year = new Date().getFullYear()
      for(let idx = 0; idx < n; idx++) {
        result.push(year - n + idx + 1)
      }
      return result
    },
    getStairTypeName(stairType) {
      return constants.STAIR_TYPE_MAP[stairType]
    },
    fetchPriceingDataByStairstep() {
      getPriceingDataByStairstep({
        year: this.criteria.selectedYear,
      }).then(res => {
        this.pricingData = res.result ? res.result.list : []
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/sysmodule/waterfee/pricing/stairstep-search.vue